import * as actionTypes from '../actions/actionTypes';
import { updateObject, getParameterByName } from '../../shared/utility';
import setAuthToken from 'shared/setAuthToken';
import jwt_decode from 'jwt-decode';
import { readSettingsStart } from '../actions';

const initialState = {
  token: localStorage.getItem('token'),
  error: null,
  origin: null,
  loading: false,
  message: '',
  permObj: null,
  loggedInStatus: false,
  picture: null
}

const setStart = (state, action) => {
  return updateObject(state, {
    message: ''
  });
}

const setLoading = (state, action) => {
  return updateObject(state, {
    loading: true,
    message: ''
  });
}

const setRedirect = (state, action) => {
  const origin = getParameterByName('o') ? getParameterByName('o') : 'none';
  
  const { token } = action.user;
  localStorage.setItem('token', token);
  setAuthToken(token);
  const decoded = jwt_decode(token);
  
  return updateObject(state, {
    token: action.payload,
    message: '',
    loading: false,
    origin,
    permObj: decoded.permObj,
    loggedInStatus: true
  });
}

const setLogout = (state, action) => {
  localStorage.removeItem('token');
  return updateObject(state, {
    origin: null});
}

const setMessageError = (state, action) => {
  return updateObject(state, {
    message: 'Credentials Invalid',
    loading: false
  });
}

const setChecked = (state, action) => {
  return updateObject(state, {
    message: '',
    loading: false
  })
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_REQUEST: {
      return setLoading(state, action);
    }
    case actionTypes.AUTH_START: {
      return setStart(state, action);
    }
    case actionTypes.AUTH_SUCCESS: {
      return setRedirect(state, action);
    }
    case actionTypes.AUTH_FAILURE: {
      return setMessageError(state, action);
    }
    case actionTypes.AUTH_LOGOUT: {
      return setLogout(state, action);
    }
    case actionTypes.AUTH_CHECKED: {
      return setChecked(state, action);
    }
    default:
      return state;
  }
};

export default authReducer;
